// Libraries
var React = require('react');

class MidfielderLineupStats extends React.Component {
	render() {
		return (
			<div>
				<div className="LineupPlayer__stats">
					{!isNaN(this.props.MinutesPlayed) && this.props.MinutesPlayed > 0 &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Minutes Played</p>
								<p className="LineupPlayer__stat--value">{this.props.MinutesPlayed}</p>
							</div>
					}

					{!isNaN(this.props.GoalsScored) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Goals Scored</p>
								<p className="LineupPlayer__stat--value">{this.props.GoalsScored}</p>
							</div>
					}

					{!isNaN(this.props.Assists) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Assists</p>
								<p className="LineupPlayer__stat--value">{this.props.Assists}</p>
							</div>
					}

					{!isNaN(this.props.TotalPasses) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Total Passes</p>
								<p className="LineupPlayer__stat--value">{this.props.TotalPasses}</p>
							</div>
					}

					{!isNaN(this.props.CompletedPasses) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Completed Passes</p>
								<p className="LineupPlayer__stat--value">{this.props.CompletedPasses}</p>
							</div>
					}

					{!isNaN(this.props.Touches) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Touches</p>
								<p className="LineupPlayer__stat--value">{this.props.Touches}</p>
							</div>
					}

					{!isNaN(this.props.YellowCards) && !isNaN(this.props.RedCards) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Cards</p>
								<p className="LineupPlayer__stat--value"><span className="yellowcard" aria-label="Number of yellow cards">{this.props.YellowCards}</span> <span className="redcard" aria-label="Number of red cards">{this.props.RedCards}</span></p>
							</div>
					}
				</div>
			</div>
		)
	}
}

module.exports = MidfielderLineupStats;



// WEBPACK FOOTER //
// ./src/components/MDC/Lineup/MidfielderLineupStats.js